module.exports = __webpack_public_path__ + "img/face-tip.8824bfe.png";


//////////////////
// WEBPACK FOOTER
// ./components/face-auth-qrcode/face-tip.png
// module id = sWRn
// module chunks = 12 13 38 39 51 53 58 74 95 111 129 133 151